// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__tb6uv","productName":"Table_productName__3dCoe"};